import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import "./Users.css";
import AbmButtons from "../ABMbotones/abmButtons";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Pagination from "react-bootstrap/Pagination";
import { Badge, Button, Modal } from "react-bootstrap";
import AnimacionSuccessful from "../AnimacionSuccessful/animacionSuccessful";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import CargaViaExcelUsers from "../CargaViaExcel/Users/CargaViaExcelUsers";
import SpinnerComponent from "../SpinnerComponent/SpinnerComponent";
import { forwardRef } from 'react';
import api from "../../utils/axios";

const UsersList = () => {
  function refreshPage() {
    window.location.reload(false);
  }

  const navigate = useNavigate();
  const [UserSelected, setUserSelected] = useState(null);
  const [isAdmin, setIsAdmin] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(8);
  // const [filteredData, setFilteredData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [allUsers, setAllUsers] = useState([]);
  const [filter, setFilter] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  // Estados para AnimacionSuccessful
  const [errorBool, setErrorBool] = useState(false);
  const [avisomsg, setAvisomsg] = useState('');
  const [variable, setVariable] = useState(false);

  const seleccionar = React.useCallback((provider) => {
    if (provider.email === "admin@admin.com" || provider.email === "user@user.com") {
      return;
    }
    setUserSelected(provider._id);
  }, []);

  const deseleccionar = React.useCallback(() => {
    setUserSelected(null);
  }, []);


  // useEffect(() => {
  //   (async () => {
  //     try {
  //       setIsLoading(true)
  //       const response = await axios.get(`${BACK_APP_URI}/users`, {
  //         headers: {
  //           Authorization: `${Cookies.get("token")}`,
  //         },
  //       });

  //       setAllUsers(response.data.users)
  //       setIsAdmin(response.data.userdata)

  //       setIsLoading(false)
  //     } catch (error) {
  //       setIsLoading(false)
  //       console.error(error)
  //     }
  //   })()

  // }, [])
  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        const response = await api.get("/users/paginated", {
          params: {
            page: activePage,
            limit: itemsPerPage,
            search: filter,
          },
        });

        setAllUsers(response.data.users);
        setIsAdmin(response.data.userdata);

        // pages desde la metadata del backend
        setTotalPages(response.data.pagination.totalPages);

        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error(error);
      }
    })();
  }, [activePage, itemsPerPage, filter]);


  // const filteredData = React.useMemo(() => {
  //   return allUsers.filter(
  //     (item) =>
  //       (item.lname || "").toLowerCase().includes(filter.toLowerCase()) ||
  //       (item.fname || "").toLowerCase().includes(filter.toLowerCase()) ||
  //       (item.position || "").toLowerCase().includes(filter.toLowerCase()) ||
  //       (item.email || "").toLowerCase().includes(filter.toLowerCase()) ||
  //       (item.roleName || "").toLowerCase().includes(filter.toLowerCase())
  //   );
  // }, [allUsers, filter]);

  // const totalPages = React.useMemo(() => {
  //   return Math.ceil(filteredData.length / itemsPerPage);
  // }, [filteredData, itemsPerPage]);

  // const currentPageData = React.useMemo(() => {
  //   const startIndex = (activePage - 1) * itemsPerPage;
  //   return filteredData.slice(startIndex, startIndex + itemsPerPage);
  // }, [filteredData, activePage, itemsPerPage]);


  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
    setActivePage(1);
  };

  const deleteCustomer = async () => {
    try {
      await api.delete(`/users/delete/${UserSelected}`);
      setVariable(true);
      setErrorBool(false);
      setAvisomsg('Usuario eliminado correctamente');
    } catch (error) {
      console.error(error);
      setVariable(true);
      setErrorBool(true);
      setAvisomsg('Error al eliminar usuario');
    }
  };

  const ForwardedCargaViaExcelUsers = React.forwardRef((props, ref) => (
    <CargaViaExcelUsers ref={ref} {...props} />
  ))

  return (
    <>
      <div className="main-container">
        <div className="header--container">
          <div className="header-row-user">
            <h1 className="title--header">Usuarios</h1>

            <Form className="all-tag-form">
              <InputGroup>
                <Form.Control
                  className="all-tag-search"
                  value={filter}
                  onChange={handleFilterChange}
                  placeholder="Buscar usuarios"
                />
              </InputGroup>
            </Form>
          </div>
        </div>
        <div className="card--container">
          <div className="btn-filter ">
            <h3 className="text-filter">Carga Excel</h3>
            <Tooltip title="Carga por excel" arrow>
              <ForwardedCargaViaExcelUsers />
            </Tooltip>
          </div>
          {/* <SpinnerComponent isLoading={isLoading} isAlternative={!currentPageData.length} alternative={<div>No se encontraron usuarios</div>} > */}
          <SpinnerComponent
            isLoading={isLoading}
            isAlternative={!allUsers.length}
            alternative={<div style={{ textAlign: "center" }}>No se encontraron usuarios</div>}
          >

            <div className="table-container table-responsive">
              <Table className="table-striped table-bordered table-hover">
                <thead responsive >
                  <tr onClick={() => deseleccionar()}>
                    <th className="title-th">Apellido Nombre</th>
                    <th className="title-th">Cargo</th>
                    <th className="title-th">Usuario</th>
                    <th className="title-th">Rol</th>
                    <th className="title-th">Laboratorios</th>
                    <th className="title-th">Pedido extra</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {currentPageData.map((user) => ( */}
                  {allUsers.map((user) => (

                    <tr
                      key={user._id}
                      onClick={() => seleccionar(user)}
                      className={user._id === UserSelected ? "selected-row tr-table" : "tr-table"}
                    >
                      <td>{`${user.lname || "N/A"} ${user.fname || "N/A"}`}</td>
                      <td>{user.position || "N/A"}</td>
                      <td>{user.username || "N/A"}</td>
                      <td>
                        {user.roleName === "admin"
                          ? "Administrador"
                          : user.roleName === "sede"
                            ? "Usuario"
                            : user.roleName === "logistic"
                              ? "Inventario"
                              : "N/A"}
                      </td>
                      <td>
                        {user.labs?.length > 0 ? user.labs.map((lab, index) => (
                          <Badge key={index} className="ml-2">
                            {lab?.name || "N/A"}
                          </Badge>
                        )) : "N/A"}
                      </td>
                      {((user.labOrders?.some(lo => lo.extraOrder) ?? false) === true) && user.roleName === "sede" ? (
                        <td className="text-success">Habilitado</td>
                      ) : (
                        <td></td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </SpinnerComponent>

          {variable && (
            <AnimacionSuccessful
              errorBool={errorBool}
              avisomsg={avisomsg}
              refreshPage={refreshPage}
            />
          )}
        </div>

        {totalPages > 1 && (
          <Pagination className="pagination-all-tag">

            <Pagination.Prev
              onClick={() => handlePageChange(activePage > 1 ? activePage - 1 : 1)}
              disabled={activePage === 1}
            />

            {Array.from({ length: totalPages }, (_, index) => {
              const page = index + 1;
              const shouldShow = Math.abs(activePage - page) <= 2;

              if (!shouldShow) return null;

              return (
                <Pagination.Item
                  className="pag-item-all-tag"
                  key={page}
                  active={page === activePage}
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </Pagination.Item>
              );
            })}

            <Pagination.Next
              onClick={() =>
                handlePageChange(activePage < totalPages ? activePage + 1 : totalPages)
              }
              disabled={activePage === totalPages}
            />

          </Pagination>
        )}




        <AbmButtons
          item={UserSelected}
          abm={"user"}
          funcion={deleteCustomer}
          role={isAdmin}
        />
      </div>
    </>
  );
};

export default UsersList;
